export default {
  FETCH_BIG_WINNERS_HISTORY_REQUEST: 'FETCH_BIG_WINNERS_HISTORY_REQUEST',
  FETCH_BIG_WINNERS_HISTORY_SUCCESS: 'FETCH_BIG_WINNERS_HISTORY_SUCCESS',
  FETCH_BIG_WINNERS_HISTORY_FAILURE: 'FETCH_BIG_WINNERS_HISTORY_FAILURE',

  DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_REQUEST: 'DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_REQUEST',
  DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_SUCCESS: 'DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_SUCCESS',
  DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_FAILURE: 'DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/big-winners/action-types.js